<mat-card>
    <mat-card-content>
        <div class="chat-dialog-container">
            <div style="display: flex; justify-content: space-between; margin-bottom: 10px; align-items: flex-start;     padding: 20px !important;">
                <!-- Left Section -->
                <div style="display: flex; flex-direction: row; gap: 20px; align-items: flex-start;">
                    <div style="display: flex; flex-direction: column;">
                        <span style="color: white;
                                    font-size: 1.1em;
                                    background-color: #ffc107;
                                    color: black;
                                    padding: 5px 5px;
                                    border-top-left-radius: 5px;
                                    border-top-right-radius: 5px;">
                            Amco ID
                        </span>
                        <span style="color: white;
                                    font-size: 1.1em;
                                    padding: 4px;
                                    border: 1px solid rgba(255, 193, 7, 0.4);

                                    text-align: center;">
                            {{ amcoId }}
                        </span>
                    </div>
                    <div *ngIf="!isCustomsChat && !isBmwChat" style="display: flex; flex-direction: column;">
                        <span style="color: white;
                                    font-size: 1.1em;
                                    background-color: #ffc107;
                                    color: black;
                                    padding: 5px 5px;
                                    border-top-left-radius: 5px;
                                    border-top-right-radius: 5px;">
                            Topic
                        </span>
                        <span style="color: white;
                                    font-size: 1.1em;
                                    padding: 4px;
                                    border: 1px solid rgba(255, 193, 7, 0.4);

                                    text-align: center;">
                            {{ topic }}
                        </span>
                    </div>

                    <div *ngIf="!isCustomsChat && !isBmwChat" style="display: flex; flex-direction: column;">
                        <span style="color: white;
                                    font-size: 1.1em;
                                    background-color: #ffc107;
                                    color: black;
                                    padding: 5px 5px;
                                    border-top-left-radius: 5px;
                                    border-top-right-radius: 5px;">
                            Priority
                        </span>
                        <span style="color: white;
                                    font-size: 1.1em;
                                    padding: 4px;
                                    border: 1px solid rgba(255, 193, 7, 0.4);

                                    text-align: center;">
                           {{ priority | titlecase }}
                        </span>
                    </div>
                </div>

                <!-- Right Section -->
                <div *ngIf="!isCustomsChat && !isBmwChat" style="display: flex; flex-direction: column;">
                    <span style="color: white; font-size: 1.1em; background-color: #ffc107; color: black; padding: 5px 10px; border-top-left-radius: 5px; border-top-right-radius: 5px;">
                        Status
                    </span>
                    <span style="    color: white;
                    font-size: 1.1em;
                    padding: 4px;
                    border: 1px solid rgba(255, 193, 7, 0.4);

                    text-align: center;">
                        {{ status === true ? 'Open' : 'Resolved' }}
                    </span>
                </div>
            </div>



            <div style="display:  grid !important; flex: 1 !important; overflow-y: auto !important; margin-bottom: 10px !important; padding-right: 10px !important; max-height: 50vh;     padding: 10px;
            background: lightgrey;
            margin-left: -16px;
            margin-right: -16px;">
                <div
                *ngFor="let message of messages"
                class="message-bubble"
                [ngClass]="{
                  'control-room': message.type === 'ControlTower',
                  'other-user': message.type !== 'ControlTower'
                }"
              >
                <p [innerHTML]="message.message"></p>
                <span class="timestamp">
                  {{ message.createdBy }} – {{ message.createdAt | date: 'short' }}
                </span>
              </div>
            </div>
            <div style="display: flex;
            gap: 10px;
            align-items: center;">
                <mat-form-field style="width: 425px;">
                    <textarea class="textinputupdate" rows="2"
                    placeholder="Type your message here..." matInput [(ngModel)]="newMessage"></textarea>
                </mat-form-field>
                <button
                    style="  font-size: 10px;
                    margin-right: 5px;
                    scale: 1;
                    background:#077f67;
                    color: white;
                    border-radius: 0px;
                    text-shadow: none;
                    box-shadow: none;
                    flex: 1 1 100%;
                    box-sizing: border-box;
                    max-width: 50px;
                    cursor: pointer;
                    transition: background-color 0.3s;
                    box-shadow: none !important;
                    margin-top: 67px;
                    height: 50px;"
                    mat-raised-button
                    (click)="addMessage()"
                >
                    Send
                </button>
                <button
                    style="  font-size: 10px;
                    margin-right: 5px;
                    scale: 1;
                    background: #c42c2c;
                    color: white;
                    border-radius: 0px;
                    text-shadow: none;
                    box-shadow: none;
                    flex: 1 1 100%;
                    box-sizing: border-box;
                    max-width: 50px;
                    cursor: pointer;
                    transition: background-color 0.3s;
                    box-shadow: none !important;
                    margin-top: 67px;
                    height: 50px;"
                    mat-raised-button
                    (click)="onCancelClick()"
                >
                    Close Chat
                </button>
            </div>
        </div>


    </mat-card-content>
</mat-card>
